/* eslint-disable */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Upload } from 'antd'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

import { font, greys } from 'assets/themes/theme-default'
import svg from 'assets/svg'
import { Modal, Drawer } from 'core/components/ui'
import SVG from 'core/components/svg'
import TitleIcon from 'core/layouts/title-icon'
import { isMobile } from 'react-device-detect'

import Requester from 'core/requesters/Requester'

const StyledUpload = styled(Upload)`
  && .ant-upload-select-picture-card {
    width: 100%;
  }
`
const Icon = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${greys.dark1};
  vertical-align: middle;
  cursor: pointer;
`

const DamagePicturesModal = ({ intl, ...props }) => {
  const [previewPicture, setPreviewPicture] = useState()
  const [modalVisible, setModalVisible] = useState(false)

  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }

  const handlePreview = async picture => {
    if (!picture.previewUrl) {
      picture.previewUrl = await getBase64(picture.originFileObj)
    }
    setPreviewPicture(picture.previewUrl)
    setModalVisible(true)
  }
  const handleCancelPreview = () => {
    setModalVisible(false)
  }

  const handleDownload = file => {
    const a = document.createElement('a')
    a.href = file.url
    a.target = '_blank'
    a.download = file.url.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <>
      {!isMobile ? (
        <>
          <Modal visible={props.visible} destroyOnClose onCancel={props.onClose} footer={null}>
            <TitleIcon
              title={intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-title' })}
              small
            />
            <section>
              <span>{props.title}</span>
            </section>
            <section>
              <StyledUpload
                headers={{
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('bearer')).jwt}`
                }}
                action={`${Requester.API.urlFileRender}/files/temporary`}
                onChange={props.onChange}
                onRemove={props.onRemove}
                onPreview={handlePreview}
                onDownload={handleDownload}
                method="POST"
                fileList={props.pictures}
                defaultFileList={props.pictures}
                showUploadList={{
                  showPreviewIcon: true,
                  showDownloadIcon: true,
                  showRemoveIcon: true
                }}
                listType="picture-card"
                multiple
                accept="image/*"
                beforeUpload={file => props.isFileAccepted(file)}
                maxCount={5}
                disabled={props.pictures && props.pictures.length === 5}
              >
                <div>
                  <Icon svg={svg.plus} />
                  <div className="ant-upload-text">
                    {intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-upload-button' })}
                    <br />
                    <span style={{ fontSize: font.xs, color: greys.dark2, fontStyle: 'italic' }}>
                      {intl.formatMessage({ id: 'upload.max_size' }, { value: 20 })}
                    </span>
                    <br />
                    <span style={{ fontSize: font.xs, color: greys.dark2, fontStyle: 'italic' }}>
                      {intl.formatMessage({
                        id: 'tradeIn-defaults-pictures-modal-max-count-defaults'
                      })}
                    </span>
                  </div>
                </div>
              </StyledUpload>
              <Modal visible={modalVisible} footer={null} onCancel={handleCancelPreview}>
                <img alt="Preview" style={{ width: '100%' }} src={previewPicture} />
              </Modal>
            </section>
          </Modal>
        </>
      ) : (
        <>
          <Drawer
            placement="bottom"
            height="326"
            width="700px"
            visible={props.visible}
            onClose={() => props.onClose()}
            className="globaldealer-modal-vehicle-list"
            title={<span>{props.title}</span>}
          >
            <section>
              <StyledUpload
                headers={{
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('bearer')).jwt}`
                }}
                action={`${Requester.API.urlFileRender}/files/temporary`}
                onChange={props.onChange}
                onRemove={props.onRemove}
                onPreview={handlePreview}
                onDownload={handleDownload}
                method="POST"
                fileList={props.pictures}
                defaultFileList={props.pictures}
                showUploadList={{
                  showPreviewIcon: true,
                  showDownloadIcon: true,
                  showRemoveIcon: true
                }}
                listType="picture-card"
                multiple
                accept="image/*"
                beforeUpload={file => props.isFileAccepted(file)}
                maxCount={5}
                disabled={props.pictures && props.pictures.length === 5}
              >
                <div>
                  <Icon svg={svg.plus} />
                  <div className="ant-upload-text">
                    {intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-upload-button' })}
                    <br />
                    <span style={{ fontSize: font.xs, color: greys.dark2, fontStyle: 'italic' }}>
                      {intl.formatMessage({ id: 'upload.max_size' }, { value: 20 })}
                    </span>
                    <br />
                    <span style={{ fontSize: font.xs, color: greys.dark2, fontStyle: 'italic' }}>
                      {intl.formatMessage({
                        id: 'tradeIn-defaults-pictures-modal-max-count-defaults'
                      })}
                    </span>
                  </div>
                </div>
              </StyledUpload>
            </section>
          </Drawer>
          <Drawer
            visible={modalVisible}
            footer={null}
            onClose={handleCancelPreview}
            placement="bottom"
            height="326"
          >
            <img alt="Preview" style={{ width: '100%' }} src={previewPicture} />
          </Drawer>
        </>
      )}
    </>
  )
}

DamagePicturesModal.propTypes = {
  intl: PropTypes.shape().isRequired,
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  pictures: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  isFileAccepted: PropTypes.func.isRequired
}

export default injectIntl(DamagePicturesModal)
